var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayRecording(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.849C15.5735 23.8208 16.725 24.7301 18.2957 24.7301C19.8664 24.7301 21.0224 23.8208 21.5958 22.849M18.3051 24.8797V26.6282M18.2842 22.0523C17.3406 22.0523 16.5757 21.2878 16.5757 20.3447V18.9577C16.5757 18.0145 17.3406 17.25 18.2842 17.25C19.2278 17.25 19.9927 18.0145 19.9927 18.9577V20.3447C19.9927 21.2878 19.2278 22.0523 18.2842 22.0523Z",
    stroke: "#1E1F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 20.3572L10.6469 21.4298C8.74547 22.513 6.5625 20.8265 6.5625 18.2744V8.17614C6.5625 5.66308 8.68474 3.97624 10.5792 4.98352L21.4241 10.7498C22.815 11.4893 22.8699 13.8627 21.5154 14.6961",
    stroke: "#1E1F26",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayRecording);
export default __webpack_public_path__ + "static/media/play-recording.cc21fc1ee31f48665d50a98ca45385b6.svg";
export { ForwardRef as ReactComponent };